<template>
  <div>
    <top-bar title="Recuperar Senha"/>
    <loading v-if="load"/>

    <div class="container" v-if="menu === 1" v-show="!load">
      <div class="mx-auto" style="max-width: 400px">
        <div v-if="!usuario.id_cliente">
          <modal-menu :menus="menus" :selected="tipoLogin" left="true" @changeMenu="toggleTipoLogin" class="mb-3"/>
        </div>
        <form @submit.prevent="validate">
          <div v-if="tipoLogin === 1">
            <div class="form-group mb-2">
              <label class="mb-0 font-weight-bold small">Telefone *</label>
              <the-mask id="telefone" :mask="['(##) ####-####', '(##) #####-####']" class="form-control" type="tel" v-model="usuario.telefone" placeholder="(##) #####-####" :disabled="usuario.id_cliente" required/>
            </div>
            <h6 class="small font-weight-bold mt-4">Onde quer receber o código?</h6>
            <div class="btn-recuperar">
              <button class="btn btn-block" type="button" :disabled="load" @click.prevent="validate('whatsapp')">
                <span><svg xmlns="http://www.w3.org/2000/svg" class="text-primary" width="26" height="26" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M0 0h24v24H0z" stroke="none"/><path d="m3 21 1.65-3.8a9 9 0 1 1 3.4 2.9z"/><path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0za5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1"/></svg></span>
                Receber código no WhatsApp
              </button>
            </div>
            <div class="btn-recuperar">
              <button class="btn btn-block" type="button" :disabled="load" @click.prevent="validate('sms')">
                <span><svg xmlns="http://www.w3.org/2000/svg" class="text-primary" width="26" height="26" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M0 0h24v24H0z" stroke="none"/><path d="M11 3h10v8h-3l-4 2v-2h-3z"/><path d="M15 16v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2m2 13v.01"/></svg></span>
                Receber código via SMS
              </button>
            </div>
          </div>
          <div v-else>
            <div class="form-group mb-2">
              <label class="mb-0 font-weight-bold small">E-mail *</label>
              <input type="email" id="email" class="form-control" placeholder="Informe seu e-mail" v-model="usuario.email" required maxlength="100" :disabled="usuario.id_cliente">
            </div>
            <div class="btn-recuperar" v-if="tipoLogin === 2">
              <button class="btn btn-block" type="button" :disabled="load" @click.prevent="validate('email')">
                <span><svg xmlns="http://www.w3.org/2000/svg" class="text-primary" width="26" height="26" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M0 0h24v24H0z" stroke="none"/><path d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="m3 7 9 6 9-6"/></svg></span>
                Receber código no e-mail
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <troca-senha v-show="menu === 2" @reenviar="reenviar" :data-user="dadosRecuperacao"/>
  </div>
</template>

<script>
  import {TheMask} from 'vue-the-mask';
  import TrocaSenha from "../components/PerfilTrocarSenha";
  import TopBar from "../components/TopBar";
  import ModalMenu from "../components/ModalMenu";
  import Loading from "../components/Loading";

  export default {
    name: 'EsqueceuSenha',
    components: {Loading, ModalMenu, TopBar, TrocaSenha, TheMask},
    data() {
      return {
        load: false,
        tipoLogin: 1,
        menus: [
          { nome: 'Telefone', active: true },
          { nome: 'E-mail', active: true }
        ],
        usuario:  {
          email: '',
          telefone: '',
          id_cliente: null,
          recaptcha: ''
        },
        url: '',
        menu: 1,
        tipoEnvioSelecionado: ''
      }
    },

    methods: {
      toggleTipoLogin(m) {
        this.tipoLogin = m;
        this.tipoEnvioSelecionado = '';

        if (m === 2 && this.usuario.telefone) {
          this.usuario.telefone = '';
        }

        if (m === 1 && this.usuario.email) {
          this.usuario.email = '';
        }

        this.$nextTick(() => {
          this.$helpers.focusrElement(this.tipoLogin === 2 ? 'email' : 'telefone');
        });
      },

      solicitarUsuario(tipoEnvio) {
        const telefone = ((this.usuario.telefone || '') + '').replace(/\D/g, '');
        const email = ((this.usuario.email || '') + '').trim().toLowerCase();
        const dados = {
          id_cliente: this.usuario.id_cliente || null,
          tipo_envio: tipoEnvio
        };

        if (this.tipoLogin === 1) {
          dados.telefone = telefone;

        } else {
          dados.email = email;
        }

        this.$http.post(this.$store.state.base_url + 'cliente/esqueceu-senha', dados)
          .then(res => {
            this.load = false;
            const sucesso = res && res.data && (res.data.success || res.data.ok);

            if (sucesso) {
              this.tipoEnvioSelecionado = tipoEnvio;
              this.menu = 2;
              this.$emit('trocarSenha');

            } else {
              this.$swal((res.data || {}).msg || 'Erro temporário');
            }

          }, res => {
            console.log(res);
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      },

      validate(tipoEnvio = '') {
        if (typeof tipoEnvio !== 'string') {
          tipoEnvio = '';
        }

        const regex = new RegExp('^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})');

        if (this.tipoLogin === 1) {
          const telefone = ((this.usuario.telefone || '') + '').replace(/\D/g, '');

          if (!telefone || telefone.length < 10 || telefone.length > 11) {
            this.$swal(`Por favor, informe o número do Telefone em um formato válido => DDD + Número`);
            return;
          }

        } else if (!regex.test(this.usuario.email)) {
          this.$swal(`Por favor, informe um E-mail válido!`);
          return;
        }

        this.load = true;
        this.solicitarUsuario(tipoEnvio || (this.tipoLogin === 1 ? 'sms' : 'email'));
      },

      reenviar(validar) {
        this.menu = 1;
        this.$nextTick(() => {
          if (validar) {
            this.validate(this.tipoEnvioSelecionado);

          } else {
            this.usuario.email = '';
            this.usuario.telefone = '';
            this.usuario.id_cliente = null;
            this.tipoEnvioSelecionado = '';
            this.$helpers.focusrElement(this.tipoLogin === 2 ? 'email' : 'telefone');
          }
        });
      }
    },

    mounted() {
      window.scrollTo(0,0);
      this.url = this.$helpers.getUrlApp(this.$route.params.id || '');
      let user = this.$helpers.parseJSONObject(sessionStorage.getItem('recuperarSenha'));

      if (user && (user.email || user.telefone)) {
        this.usuario.id_cliente = user.id_cliente || null;
        this.usuario.email = user.email || '';
        this.usuario.telefone = user.telefone || '';
        this.tipoLogin = this.usuario.telefone ? 1 : 2;

        if (this.tipoLogin === 2) {
          this.validate('email');
        }

      } else {
        this.$nextTick(() => {
          this.$helpers.focusrElement('telefone');
        });
      }
    },

    computed: {
      dadosRecuperacao() {
        return {
          email: this.tipoLogin === 1 ? this.usuario.telefone : this.usuario.email,
          telefone: this.usuario.telefone,
          id_cliente: this.usuario.id_cliente,
          canal_recuperacao: this.tipoEnvioSelecionado
        };
      }
    }
  }
</script>
<style scoped>
.btn-recuperar {
  border-bottom: 1px solid #C4C7C5;
  margin-bottom: 6px;
}

.btn-recuperar .btn.btn-block {
  text-align: left;
  margin-bottom: 0;
  padding: 12px 6px;
}

.btn-recuperar span {
  text-align: center;
  margin-right: 6px;
}
</style>
